import SVGIconWrapper from "./SVGIconWrapper"

const IconTagSingle = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 239.21 239.21"
        iconClass={`icon--tag-single ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M102.12 239.21a5 5 0 0 1-3.54-1.46L1.46 140.63a5 5 0 0 1 0-7.07L133.55 1.46A5 5 0 0 1 137.09 0h97.12a5 5 0 0 1 5 5v97.12a5 5 0 0 1-1.46 3.54L105.66 237.75a5 5 0 0 1-3.54 1.46zM12.07 137.09l90.05 90.05 127.09-127.09V10h-90.05z" />
        <path d="M187.71 73a21.5 21.5 0 1 1 21.5-21.5 21.52 21.52 0 0 1-21.5 21.5zm0-33a11.5 11.5 0 1 0 11.5 11.5 11.51 11.51 0 0 0-11.5-11.5z" />
    </SVGIconWrapper>
)

export default IconTagSingle